import { ButtonSize } from '../buttonSize'

export interface StyledProps {
  size: ButtonSize
  $onlyIcon: boolean
}
